<ng-container *ngIf="vo$ | async; let vo">
	<ng-container [ngSwitch]="vo.status">
		<div
			*ngSwitchCase="Status.Unpublish"
			class="app-status-badge unpublished">
			<mat-icon [svgIcon]="DcIcons.ShareOff"></mat-icon>
			<span
				i18n="@@general.status.unpublished">
				unpublished</span>
		</div>

		<div
			*ngSwitchCase="Status.UnAvailable"
			class="app-status-badge unavailable">
			<mat-icon [svgIcon]="DcIcons.ShareOff"></mat-icon>
			<span
				i18n="@@general.status.unavailable">
				unavailable</span>
		</div>

		<div
			*ngSwitchCase="Status.Available"
			class="app-status-badge available">
			<mat-icon [svgIcon]="DcIcons.Share"></mat-icon>
			<span
				i18n="@@general.status.available">
				available</span>
		</div>

		<div
			*ngSwitchCase="Status.Running"
			class="app-status-badge running">
			<mat-icon>
				<mat-spinner [diameter]="15"></mat-spinner>
			</mat-icon>
			<span
				i18n="@@general.status.running">
				running</span>
		</div>

		<div
			*ngSwitchCase="Status.Waiting"
			class="app-status-badge waiting">
			<mat-icon>
				<mat-spinner [diameter]="15"></mat-spinner>
			</mat-icon>
			<span
				i18n="@@general.status.waiting">
				waiting</span>
		</div>

		<div
			*ngSwitchCase="Status.Success"
			class="app-status-badge success">
			<mat-icon [svgIcon]="DcIcons.Check"></mat-icon>
			<span
				i18n="@@general.status.success">
				success</span>
		</div>

		<div
			*ngSwitchCase="Status.Error"
			class="app-status-badge error">
			<mat-icon [svgIcon]="DcIcons.Error"></mat-icon>
			<span
				i18n="@@general.status.error">
				error</span>
		</div>

		<div
			*ngSwitchCase="Status.InProgress"
			class="app-status-badge running">
			<mat-icon [svgIcon]="DcIcons.Flash"></mat-icon>
			<span
				i18n="@@general.status.inProgress">
				in-progress</span>
		</div>

		<div
			*ngSwitchCase="Status.Absent"
			class="app-status-badge absent">
			<mat-icon [svgIcon]="DcIcons.Absent"></mat-icon>
			<span
				i18n="@@general.status.absent">
				absent</span>
		</div>

		<div
			*ngSwitchCase="Status.NotUsed"
			class="app-status-badge not-used">
			<mat-icon [svgIcon]="DcIcons.NotUsed"></mat-icon>
			<span
				i18n="@@general.status.notUsed">
				not-used</span>
		</div>

		<div
			*ngSwitchCase="Status.Paused"
			class="app-status-badge paused">
			<mat-icon [svgIcon]="DcIcons.FlashOff"></mat-icon>
			<span
				i18n="@@general.status.paused">
				paused</span>
		</div>

		<div
			*ngSwitchCase="Status.Synced"
			class="app-status-badge synced">
			<mat-icon [svgIcon]="DcIcons.Synced"></mat-icon>
			<span
				i18n="@@general.status.synced">
				synced</span>
		</div>

		<div
			*ngSwitchCase="Status.NotSynced"
			class="app-status-badge not-synced">
			<mat-icon [svgIcon]="DcIcons.NotSynced"></mat-icon>
			<span
				i18n="@@general.status.not-synced">
				not-synced</span>
		</div>
	</ng-container>
</ng-container>
